// Dependecies
import { useState, useEffect } from 'react';

// Store
import user from '../../store/user';
import dashboardCompany from '../../store/dashboardCompany';

function useGeneralInformation(plate) {
  const [userStore] = user();
  const [, dashboardActions] = dashboardCompany();
  const [dataInformation, useSetDataInformation] = useState([]);

  useEffect(() => {
    if (userStore.token) {
      dashboardActions.setDataInformationVehicle(userStore.token, plate).then((response) => {
        useSetDataInformation(response.vehicleInformation);
      });
    }
  }, [userStore.token]);

  return {
    dataInformation,
  };
}

export default useGeneralInformation;
